import {
  IonContent,
  IonFab,
  IonFabButton,
  IonIcon,
  IonPage,
  IonRouterContext,
} from '@ionic/react';
import { addOutline } from 'ionicons/icons';
import { ReactElement, useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Can } from '../../api/authorization.provider';
import { Machine, useGetTeamQuery } from '../../api/graphql/generated';
import { BookmarkType } from '../../api/hooks/bookmark.hooks';
import { PageHeader } from '../../components/header/page.header';
import { MachinesList } from '../../components/machine/machines-list';
import { RegisterMachineModal } from '../../components/machine/registration/register-machine-modal';
import { trackInitiateRegisterMachine } from '../../config/analytics';
import { useBeaconRouter } from '../../route/route.hooks';

interface TeamMachinesPageProps {
  id: string;
}

const TeamMachinesPage = (props: TeamMachinesPageProps): ReactElement => {
  const { id } = props;
  const { i18n } = useTranslation();

  const { data } = useGetTeamQuery({ variables: { input: { id } } });
  const [isShowingCreateModal, setShowingCreateModal] =
    useState<boolean>(false);
  const { push } = useContext(IonRouterContext);

  const { builder } = useBeaconRouter();

  let title: string = i18n.t('common:robots');
  let description;

  if (data?.getTeam) {
    title = `${data.getTeam.name} - ${i18n.t('common:robots')}`;
    description = data.getTeam.description ?? undefined;
  }

  const onDidDismiss = useCallback(
    (machine?: Machine) => {
      setShowingCreateModal(false);
      if (machine) {
        push(builder.getMachineRoute(id, machine.id));
      }
    },
    [push, builder, id]
  );

  return (
    <IonPage>
      <PageHeader
        title={title}
        subtitle={description}
        bookmarkProps={{ enable: true, type: BookmarkType.MACHINE }}
      />
      <IonContent>
        <MachinesList teamId={id} />
        <Can I="create" a="machine">
          <IonFab vertical="bottom" horizontal="end" slot="fixed">
            <IonFabButton
              // routerLink={`${Routes.TEAMS}/${id}/machines/new`}
              onClick={() => {
                setShowingCreateModal(true);
                trackInitiateRegisterMachine();
              }}
            >
              <IonIcon icon={addOutline} />
            </IonFabButton>
          </IonFab>
          <RegisterMachineModal
            isOpen={isShowingCreateModal}
            teamId={id}
            onDidDismiss={onDidDismiss}
          />
        </Can>
      </IonContent>
    </IonPage>
  );
};

export { TeamMachinesPage };
